module.exports = __webpack_public_path__ + "static/media/cash.383e1196.svg";